import { useTheme } from '@emotion/react';
import { useAtom } from 'jotai';
import React, { useEffect, useRef } from 'react';

import { Alert, Box, Grid, ScrollBox } from '~/components/blocks';
import { lineVisitorHistoryPageInfoState } from '~/state/reception/atoms';

import { History } from './History';
import { HistoryPagination } from './HistoryPagination';
import { useFetchAppointments } from './use-fetch-appointments';

type Props = {
  lineVisitorId: string;
};

export const HistoryPane = React.memo((props: Props) => {
  const theme = useTheme();
  const scrollRef = useRef<RefAttributeType<typeof ScrollBox> | null>(null);

  const { loading, appointments } = useFetchAppointments(scrollRef);
  const hasAppointments = appointments.length > 0;

  const [pageInfo, setPageInfo] = useAtom(lineVisitorHistoryPageInfoState);

  useEffect(() => {
    if (props.lineVisitorId !== pageInfo.lineVisitorId) {
      setPageInfo((_state) => ({
        ..._state,
        lineVisitorId: props.lineVisitorId,
        page: 1,
        totalPage: 1,
      }));
    }
  }, [pageInfo.lineVisitorId, props.lineVisitorId, setPageInfo]);

  return (
    <>
      {hasAppointments && (
        <Grid
          height="100%"
          gridTemplateRows="1fr min-content"
          gridTemplateColumns="1fr"
          padding={theme.space.l}
        >
          <>
            <ScrollBox loading={loading} ref={scrollRef}>
              <Box>
                {appointments.map((appointment) => (
                  <History key={appointment.id} appointment={appointment} />
                ))}
              </Box>
            </ScrollBox>
            <HistoryPagination />
          </>
        </Grid>
      )}
      {!loading && !hasAppointments && (
        <Box padding={`${theme.space.m} ${theme.space.l}`}>
          <Alert status="info" marginTop={theme.space.l}>
            履歴はありません
          </Alert>
        </Box>
      )}
    </>
  );
});

HistoryPane.displayName = 'HistoryPane';
